import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export interface INotifAuthState {
  notification?: string
}

namespace NotifAuthRedux {
  export const actionTypes = {
    SetNotification: '[SetNotification] Action',
    SetClearNotification: '[SetClearNotification] Action',
  }

  export const initialNotifAuthState: INotifAuthState = {
    notification: '',
  }

  export const reducer = () =>
    persistReducer<INotifAuthState, ActionWithPayload<INotifAuthState>>(
      {
        storage,
        key: 'NOTIFICATION',
        whitelist: [''],
      },
      (state: INotifAuthState = initialNotifAuthState, action = {type: ''}) => {
        switch (action.type) {
          case actionTypes.SetNotification: {
            const notification = action.payload?.notification

            return {...state, notification}
          }

          case actionTypes.SetClearNotification: {
            return initialNotifAuthState
          }

          default:
            return state
        }
      }
    )

  export const actions = {
    setNotification: (notification: string) => ({
      type: actionTypes.SetNotification,
      payload: {notification},
    }),
    setClearNotification: () => ({
      type: actionTypes.SetClearNotification,
    }),
  }
}

export default NotifAuthRedux
